import Mock from 'mockjs'

const mockData = Mock.mock({
  'data|3-6': [{
    'name': '@NAME',
    'creatDate': '@DATE',
    'address': '@CITY',
    'zip': '@ZIP'
  }]
})

export default {
  data: null,
  columns: [
    {
      label: '加盟商名称',
      prop: 'orgName'
    },
    {
      label: '已结束比赛场次(数)',
      prop: 'ctCount'
    },
    {
      label: '未结束比赛场次(数)',
      prop: 'ctCountNoEnd'
    },
    {
      label: '已结束比赛总额(元)',
      prop: 'endTotalAmountCt'
    },
    {
      label: '已结束培训场次(数)',
      prop: 'trCount'
    },
    {
      label: '未结束培训场次(数)',
      prop: 'trCountNoEnd'
    },
    {
      label: '已结束培训总额(元)',
      prop: 'endTotalAmountTr'
    },
    {
      label: '约场地总额(元)',
      prop: 'placeAmt'
    },
    {
      label: '不含退款收入(元)',
      prop: 'totalAmount'
    },
    {
      label: '加盟费(元)',
      prop: 'totalFranchise'
    },
    {
      label: '加盟商打款总额(元)',
      prop: 'totalAmountFranchiseePay'
    },
    {
      label: '退款余额(元)',
      prop: 'refundBalance'
    },
    {
      label: '提现手续费(元)',
      prop: 'serviceFee'
    },
    {
      label: '开户名',
      prop: 'accountName'
    },
    {
      label: '开户行',
      prop: 'accountBank'
    },
    {
      label: '账号',
      prop: 'accountNo'
    },
    {
      label: '税号',
      prop: 'taxId'
    },
    {
      label: '地址',
      prop: 'accountAddress'
    },
    {
      label: '联系人',
      prop: 'orgContactName'
    },
    {
      label: '联系电话',
      prop: 'orgContactPhone'
    },
  ]
}
